import React from "react";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  icon?: string;
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({title, subtitle, icon, className}) => (
  <div className={`page-header text-center mb-4 ${className || ""}`}>
    <h1 className="page-title">
      {icon && <i className={`${icon} page-title-icon`} />}
      {title}
    </h1>
    {subtitle && <p className="page-subtitle text-muted">{subtitle}</p>}
  </div>
);

export default PageHeader;
